module.exports = __webpack_public_path__ + "static/media/roelogo2.84e16ad9.png";